/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CodeStub } from './CodeStub'
import { Service } from './Service'

export class ResultInfo {
  constructor(json: JSON | any) {
    Object.assign(this as ResultInfo, json)
  }

  ssin?: string
  lastName?: string
  firstName?: string
  dateOfBirth?: number
  sex?: string
  documentId?: string
  protocol?: string
  complete?: boolean
  demandDate?: number
  labo?: string
  engine?: string
  codes?: Array<CodeStub>
  services?: Array<Service>
}
